/* eslint-disable react/jsx-props-no-spreading */
import { Button } from '@coop/components';
import * as React from 'react';

/**
 * A Button that navigates to an Epi page
 * Will eventually provide SPA navigation for CMS links
 */
const ButtonEpiLink = React.forwardRef<
    HTMLAnchorElement,
    React.ComponentPropsWithoutRef<typeof Button> & {
        linkUrl: string | undefined;
        target?: '_self' | '_blank';
    }
>((props, ref) => {
    const { linkUrl, target, ...buttonProps } = props;

    if (!linkUrl) {
        return null;
    }

    const anchorRel = target?.includes('blank') ? 'noopener noreferrer' : undefined;

    return (
        <Button {...buttonProps} asChild>
            <a ref={ref} href={linkUrl} target={props.target} rel={anchorRel}>
                {props.children}
            </a>
        </Button>
    );
});

export default ButtonEpiLink;
